const styles = theme => ({
  rootContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    width: '740px',
    height: '52vh',
    overflow: 'auto',
    paddingTop: '6px',
  },
  scrollableContainer: {
    marginRight: '16px',
  },
  header: {
    fontSize: '14px',
    fontWeight: 500,
    fontFamily: 'Inter',
    color: '#000',
    marginLeft: '8px',
  },
  uploadSection: {
    marginTop: theme.spacing(2),
  },
  numberInputContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  numberInputLabel: {
    flex: 1,
    fontSize: '14px',
    fontWeight: 500,
  },
  numberInput: {
    width: '120px',
    '& .MuiInputBase-root': {
      height: '40px',
    },
  },
  inputButton: {
    cursor: 'pointer',
    padding: theme.spacing(0, 1),
    userSelect: 'none',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2),
    gap: theme.spacing(2),
  },
  addButton: {
    minWidth: '150px',
  },
  listContainer: {
    maxHeight: '260px',
    overflow: 'auto',
  },
  aiHelpText: {
    color: theme.palette.text.secondary,
    fontSize: '11px',
    fontWeight: 400,
    fontFamily: 'Inter',
  },
})

export default styles
